"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.staticRenderFns = exports.render = void 0;
var render = exports.render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy;
  return _c("div", {
    staticClass: "form-block"
  }, [_c("div", {
    staticClass: "source"
  }, [_c("el-form", {
    ref: "formData",
    staticClass: "demo-form",
    attrs: {
      model: _vm.formData,
      "status-icon": "",
      rules: _vm.rules,
      "label-width": "160px",
      "label-position": "left"
    }
  }, [_c("el-form-item", {
    attrs: {
      label: "Enabled",
      prop: "enabled"
    }
  }, [_c("el-switch", {
    model: {
      value: _vm.formData.enabled,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "enabled", $$v);
      },
      expression: "formData.enabled"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Name",
      prop: "name"
    }
  }, [_c("el-input", {
    attrs: {
      name: "name",
      required: "",
      placeholder: "Name"
    },
    model: {
      value: _vm.formData.name,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "name", $$v);
      },
      expression: "formData.name"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Title",
      prop: "title"
    }
  }, [_c("el-input", {
    attrs: {
      name: "title",
      required: "",
      placeholder: "Title"
    },
    model: {
      value: _vm.formData.title,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "title", $$v);
      },
      expression: "formData.title"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Tag Line",
      prop: "tagLine"
    }
  }, [_c("el-input", {
    attrs: {
      name: "tagLine",
      placeholder: "Tag Line"
    },
    model: {
      value: _vm.formData.tagLine,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "tagLine", $$v);
      },
      expression: "formData.tagLine"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Description",
      prop: "description"
    }
  }, [_c("el-input", {
    attrs: {
      name: "description",
      type: "textarea",
      autosize: {
        minRows: 2,
        maxRows: 4
      },
      required: "",
      placeholder: "Description"
    },
    model: {
      value: _vm.formData.description,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "description", $$v);
      },
      expression: "formData.description"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Image",
      prop: "image"
    }
  }, [_c("file-upload", {
    attrs: {
      "file-list": _vm.image,
      accept: ".jpg, .jpeg, .png"
    },
    on: {
      change: _vm.fileUploaded
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Start Colour",
      prop: "startColour"
    }
  }, [_c("el-input", {
    attrs: {
      name: "startColour",
      required: "",
      placeholder: "Start Colour"
    },
    model: {
      value: _vm.formData.startColour,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "startColour", $$v);
      },
      expression: "formData.startColour"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "End Colour",
      prop: "endColour"
    }
  }, [_c("el-input", {
    attrs: {
      name: "endColour",
      required: "",
      placeholder: "End Colour"
    },
    model: {
      value: _vm.formData.endColour,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "endColour", $$v);
      },
      expression: "formData.endColour"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "Start Value",
      prop: "startValue"
    }
  }, [_c("el-input-number", {
    attrs: {
      name: "startValue",
      required: "",
      placeholder: "Start Value"
    },
    model: {
      value: _vm.formData.startValue,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "startValue", $$v);
      },
      expression: "formData.startValue"
    }
  })], 1), _c("el-form-item", {
    attrs: {
      label: "End Value",
      prop: "endValue"
    }
  }, [_c("el-input-number", {
    attrs: {
      name: "endValue",
      required: "",
      placeholder: "End Value"
    },
    model: {
      value: _vm.formData.endValue,
      callback: function ($$v) {
        _vm.$set(_vm.formData, "endValue", $$v);
      },
      expression: "formData.endValue"
    }
  })], 1), _c("el-form-item", [_c("el-button", {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.loading,
      expression: "loading"
    }, {
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "success"
    },
    on: {
      click: _vm.submitForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.save")) + " ")]), _c("el-button", {
    directives: [{
      name: "waves",
      rawName: "v-waves"
    }],
    attrs: {
      type: "reset"
    },
    on: {
      click: _vm.resetForm
    }
  }, [_vm._v(" " + _vm._s(_vm.$t("global.form.reset")) + " ")])], 1)], 1)], 1)]);
};
var staticRenderFns = exports.staticRenderFns = [];
render._withStripped = true;